import { Injectable, NgModule } from '@angular/core';
import { Routes, RouterModule, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { FormularioService } from '../services/formulario.service';
import { take, tap } from 'rxjs/operators';
import { ListFormRs005Component } from '../views/form-rs005/list-form-rs005.component';
import { FormRs005Component } from '../views/form-rs005/form-rs005.component';
import { GeneralService } from '../services/general.service';

@Injectable({
    providedIn: 'root'
})

export class FormRs005ResolveService implements Resolve<any> {
    constructor(private formularioService: FormularioService, protected generalService: GeneralService) {
    }
    async resolve(route: ActivatedRouteSnapshot): Promise<any> {
        // tslint:disable-next-line: max-line-length
        return await this.formularioService.getById('rs005', route.params.id).pipe(take(1), tap(x => console.log('Dados: ', x?.data))).pipe(take(1)).toPromise().then((response: any) => {
            return response?.data;
        }).catch(error => {
            if(localStorage.hasOwnProperty('data_rs005')){
                const data = JSON.parse(localStorage.getItem('data_rs005'));
                // tslint:disable-next-line: arrow-return-shorthand
                const result = data.filter( element => { return element.id == route.params.id });
                return result[0];
            }
        });
    }
}


const routes: Routes = [
    { path: '', component: ListFormRs005Component },
    { path: 'novo/:type', component: FormRs005Component },
    { path: ':id/editar/:type', component: FormRs005Component, resolve: { formulario: FormRs005ResolveService } },
    // { path: ':id/detalhes/:type', component: FormRs005Component, resolve: { formulario: FormRs005ResolveService } },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class FormRs005RoutingModule {
}
